import {
	getHref,
	getUrl,
	contractUrl
} from "./utils.js"
var jweixin = require('jweixin-module');
import wechatJsSdk from '@/utils/wechatJsSdk.js'
import store from '@/store/index.js';
// 公众号分享

export class Official {
	constructor() {
	    this.defaultData = store.state.mallConfig.share
	}
	
	init(params) {
		let data = this.handleParams(params || this.defaultData);
		this.shareUrl(data);
	}
	
	getLink(url){ // 处理link路径
		let sign = uni.getStorageSync("sign");
		let user = uni.getStorageSync("userInfo") ? uni.getStorageSync("userInfo") : {};
		const queryObj = { // 拼接得参数
			sign,
			pid: user.user_id || -1,
			share_type: 1,
			mtaShareFlag: 1
		}
		let href = getHref(); //获取当前链接
		let page = getUrl(); //获取当前页面路径并带参数
		if (url) page = url;
		if (page.indexOf('/') === 0) {
			page = page.slice(1)
		}
		let _url = `${href}#/${page}`;
		_url = contractUrl(_url, queryObj);
		return _url
	}

	//在需要自定义分享的页面中调用
	shareUrl(data = {}) {
		console.log(data);
		//每次都需要重新初始化配置，才可以进行分享  
		wechatJsSdk.initJssdk(function(signData) {
			jweixin.ready(function() {
				let shareData = data;
				//分享给朋友接口  
				jweixin.updateAppMessageShareData(shareData);
				//分享到朋友圈接口  
				jweixin.updateTimelineShareData(shareData);
				// title问题 - 去除会不显示
				jweixin.onMenuShareTimeline(shareData); // 即将废弃
			});
		}, data.link);
	}

	handleParams(params) {
		return {
			title: params.share_title,  // 分享标题
			desc: params.share_desc, // 分享描述
			link: this.getLink(params.share_url), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
			imgUrl: params.share_pic, // 分享图标
		}
	}
}
